import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import {connect} from "react-redux";
import {Field, withFormik} from "formik";
import Button from "@material-ui/core/Button";
import * as Yup from "yup";
import {assignUserStand, filterStands} from "../Stand/StandAction";
import {AutocompleteUser} from "../../comun/AutocompleteUser/AutocompleteUser";
import {closeDialogAction} from "../../comun/DialogManager/DialogManagerAction";


export let AssignStandDental = ({setFieldValue, user, isSubmitting, handleSubmit, isValid, dialogData, ...props}) => {
    return (
        <React.Fragment>
            <DialogTitle>Asignar Acción {dialogData.user.name}</DialogTitle>
            <form onSubmit={handleSubmit}>
                <Field name="stand"
                       label="Asigna Acción"
                       component={AutocompleteUser}
                       labelAttr="mall"
                       load={filterStands}
                       loadParams={() => {
                           return {cleaned: true}
                       }}
                       variant="outlined"
                       className="form-control"
                />
                <Button className="form-control"
                        variant="contained" color="secondary" type="submit" disabled={isSubmitting || !isValid}>
                    Asignar</Button>
            </form>
        </React.Fragment>
    )
}
const schema = Yup.object().shape({
    user: Yup.number(),
    stand: Yup.object().required("Obligatorio")
});


AssignStandDental = withFormik(
    {
        validationSchema: schema,
        mapPropsToValues: (props) => {
            let stand = props.dialogData.user.stand;
            if (stand === null) {
                stand = {id: 0, name: 'Ninguno'};
            }
            return {
                stand: stand,
                user: props.dialogData.user.id,
            }
        },
        handleSubmit: async (vals, props) => {
            props.setSubmitting(false);
            const data = Object.assign({}, vals);
            if (data.stand) {
                if (data.stand.id !== 0) {
                    data.stand = data.stand.id;
                } else {
                    data.stand = null;
                }

            }
            try {
                const res = await props.props.onAssignStand(data);
                props.resetForm();
                props.props.onDialogClose();
            } catch (e) {

            }

        },
        displayName: 'Asignar Stand',
    }
)(AssignStandDental);

const mapDispatchToProps = dispatch => {
    return {
        onAssignStand: async vals => {
            return await assignUserStand(vals)(dispatch)
        },
        onDialogClose: () => {
            dispatch(closeDialogAction({id: "assign-user-stand-dialog"}));
        },
    }
}


AssignStandDental = connect(null, mapDispatchToProps)(AssignStandDental);
